export const firestoreConstants = {
  events: 'events',
  photos: 'photos',
  videos: 'videos',
  team: 'team',
  instagram: 'instagram'
}
